import React from "react";
import { useGameTable } from "../../../hooks/useGameTables";

interface GameTableNameProps {
  gameTableId: string;
  fallback?: string;
}

export const GameTableName: React.FC<GameTableNameProps> = ({
  gameTableId,
  fallback = "N/A",
}) => {
  const { data: gameTable, isLoading, isError } = useGameTable(gameTableId);

  if (isLoading) {
    return <span className="text-slate-400">Loading...</span>;
  }

  if (isError || !gameTable) {
    return <span className="text-slate-400">{fallback}</span>;
  }

  return <span className="text-slate-300">{gameTable.name}</span>;
};
